import React, { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { getDocument, getApproval } from "../../../actions/document.action";
import { Loading } from "../../../utils/helpers/constants";
import RoundLoader from "../../../components/loader/RoundLoader";
import {
  dateFormatterUI6,
  replaceString,
} from "../../../utils/helpers/dataHelper";
import { userTypes } from "../../../utils/helpers/constants";
import DocumentBreadCrumb from "../../../components/libs/DocumentBreadCrumb";
import SectionDetails from "../../../components/libs/SectionDetails";

export default function DocumentProcessingDetails() {
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getDocument(id));
  }, []);

  const {
    document: { document, documentLoading, docStatusLoading },
  } = useSelector(({ documentReducer }) => ({
    document: documentReducer,
  }));

  const { profile } = useSelector(({ profileReducer }) => ({
    profile: profileReducer,
  }));

  const handleApproval = () => {
    var id = document.id;
    var name = document.documentType;
    const action = document.approved ? "disapproval" : "approval";
    const payload = { id, name, action };
    dispatch(getApproval(payload));
  };

  const AddressCard = ({ address }) => {
    return (
      <div className="mb-2">
        <div>
          <span className="text-sm text-gray-400 mb-2 pr-2">Address:</span>
          {address?.locationAddress}
        </div>
        <div>
          <span className="text-sm text-gray-400 mb-2 pr-2">Country:</span>
          {address?.country}
        </div>
      </div>
    );
  };

  console.log("document  ", document);

  const loadState =
    documentLoading === Loading.FETCHING ||
    documentLoading === "" ||
    docStatusLoading[id] ||
    profile.userProfileLoading === Loading.FETCHING;

  return (
    <div className="app-content hor-content">
      <div className="container mx-2 md:container md:mx-auto">
        <AiOutlineArrowLeft
          size={25}
          onClick={() => history.goBack()}
          className="mt-2 cursor-pointer"
        />
        {[profile["userType"]] === userTypes.ROLE_USER ? null : (
          <div className="page-header">
            <div className="page-title">Document Request Details</div>
          </div>
        )}
        <div className="p-2">
          <div>
            {loadState ? (
              <RoundLoader />
            ) : (
              <div>
                <DocumentBreadCrumb
                  acceptanceStatus={document.approved}
                  data={document}
                  handleAccept={handleApproval}
                  handleDecline={handleApproval}
                  name={document?.actionPerformedBy?.fullName}
                  email={document?.actionPerformedBy?.emailAddress}
                  matricNumber={document?.actionPerformedBy?.matricNumber}
                />

                <hr />
                <SectionDetails
                  title={"Document Details:"}
                  summary="This is a summary of the document details"
                  columnOne={[
                    {
                      title: "Document Name",
                      value: replaceString(document?.documentType),
                    },
                    {
                      title: "Document Fee",
                      value: "N" + document?.documentFee,
                    },
                  ]}
                  columnTwo={[
                    {
                      title: "Document Format",
                      value: replaceString(document?.documentFormat),
                    },
                    {
                      title: "Created Date",
                      value: dateFormatterUI6(document?.createdDate),
                    },
                  ]}
                />
                <hr />
                <SectionDetails
                  title={"Delivery Details:"}
                  summary="This is a summary of the delivery details"
                  columnOne={[
                    {
                      title: "PickUp Address:",
                      value: <AddressCard address={document?.pickUpAddress} />,
                    },
                  ]}
                  columnTwo={[
                    {
                      title: "Drop-off Address:",
                      value: <AddressCard address={document?.dropOffAddress} />,
                    },
                  ]}
                />
                <hr />
                <SectionDetails
                  title={"Payment Details:"}
                  summary="This is a summary of the payment details"
                  columnOne={[
                    {
                      title: "Processing Status",
                      value: document.paymentStatus,
                    },
                  ]}
                  columnTwo={[]}
                />
                <hr />

                <SectionDetails
                  title={"Submitted Documents:"}
                  summary="This section shows the list of all submitted documents."
                  policeReport={document.policeReport}
                  courtAffidavit={document.courtAffidavit}
                  studentIdCard={document.studentIdCard}
                  notificationOfResult={document.notificationOfResult}
                  showFile={true}
                  identification={true}
                  identificationFileName={`${
                    document?.documentType ||
                    document?.actionPerformedBy?.matricNumber
                  }.${document?.identificationFormat || "pdf"}`}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
